// English structure prepared. Empty keys will fall back to Spanish automatically.
const en = {
  common: {},
  start: {},
  worlds: { list: {} },
  level: {},
  settings: {},
  pause: {},
};
export default en;
